import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=920d0f8e"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"
import style0 from "./ContextMenu.vue?vue&type=style&index=0&id=920d0f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports